import slotTypePositionCalculator from './SlotTypePositionCalculator';
export default function conditionPositionCalculator(sportType, matchPhase, slot) {
    var position = slotTypePositionCalculator(sportType, matchPhase, slot) * 10000;
    return position + (slot.condition || 0);
}



// WEBPACK FOOTER //
// ./src/components/grid/slot-arrangement-policies/positionCalculators/ConditionPositionCalculator.js